import {
  Button,
  Flex,
  Heading,
  IconButton,
  Spacer,
  Spinner,
  Text,
} from '@chakra-ui/react';
import * as React from 'react';

import { XIcon } from '@/imports/ui/chakra/feather';

import { FileIcon } from './assets/FileIcon';

type ICsvFileDropTextContent = {
  showLoader: boolean | undefined;
  isDragActive: boolean;
  uploadedFileName: string | undefined;
  onRemoveFile: (e: React.SyntheticEvent) => void;
};

export const CsvFileDropTextContent: React.FC<ICsvFileDropTextContent> = (
  props
) => {
  // To prevent user from firing react-dropzone on click on the box containing the uploaded file name
  const handlePreventClick = (e: React.SyntheticEvent): void => {
    e.stopPropagation();
  };

  switch (true) {
    case props.showLoader:
      return (
        <Flex justifyContent="center" p="4">
          <Spinner color="primary.500" />
        </Flex>
      );

    case !!props.uploadedFileName:
      return (
        <Flex
          align="center"
          bg="white"
          p="4"
          borderRadius="base"
          border="1px"
          borderColor="gray.100"
          m="2"
          w="full"
          onClick={handlePreventClick}
        >
          <FileIcon boxSize={8} color="gray.600" />

          <Text pl="4" fontWeight="semibold" color="gray.600">
            {props.uploadedFileName}
          </Text>

          <Spacer />

          <IconButton
            aria-label="Remove uploaded file"
            icon={<XIcon />}
            variant="ghost"
            colorScheme="gray"
            onClick={props.onRemoveFile}
          />
        </Flex>
      );

    case props.isDragActive:
      return (
        <Heading as="h4" size="md">
          Drop the File Here ...
        </Heading>
      );

    default:
      return (
        <>
          <Heading as="h4" size="md" color="gray.500">
            Drag and Drop a File
          </Heading>

          <Text color="gray.500" my="2">
            Or
          </Text>

          <Button variant="outline" colorScheme="gray">
            Upload CSV File
          </Button>
        </>
      );
  }
};
